var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnsfea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 41.97 7.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #77a395;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.71,1.47v1.42h2.29v1.32H1.71v1.54h2.59v1.37H0V.1H4.3V1.47H1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.69,7.12h-1.71L7.12,2.79V7.12h-1.71V.1h1.71l2.86,4.35V.1h1.71V7.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.09,6.94c-.41-.17-.73-.41-.97-.74-.24-.33-.37-.72-.39-1.18h1.82c.03,.26,.12,.46,.27,.59s.35,.21,.6,.21,.45-.06,.6-.17c.15-.12,.22-.28,.22-.49,0-.17-.06-.32-.18-.43s-.26-.21-.43-.28c-.17-.07-.41-.16-.73-.25-.45-.14-.82-.28-1.11-.42-.29-.14-.53-.35-.74-.62s-.31-.63-.31-1.07c0-.65,.24-1.17,.71-1.54,.47-.37,1.09-.55,1.85-.55s1.4,.19,1.87,.55c.47,.37,.73,.89,.76,1.55h-1.85c-.01-.23-.1-.41-.25-.54s-.35-.2-.59-.2c-.21,0-.37,.05-.5,.17s-.19,.27-.19,.47c0,.23,.11,.4,.32,.53s.55,.26,1,.41c.45,.15,.82,.3,1.1,.44,.28,.14,.53,.34,.74,.61,.21,.27,.31,.61,.31,1.03s-.1,.76-.31,1.09c-.2,.33-.5,.59-.89,.78s-.84,.29-1.37,.29-.97-.08-1.38-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.65,.1V1.47h-2.86v1.48h2.14v1.33h-2.14v2.84h-1.71V.1h4.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.26,1.47v1.42h2.29v1.32h-2.29v1.54h2.59v1.37h-4.3V.1h4.3V1.47h-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.67,1.47v1.42h2.29v1.32h-2.29v1.54h2.59v1.37h-4.3V.1h4.3V1.47h-2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.74,5.88h-2.62l-.42,1.24h-1.79L37.45,.1h1.98l2.54,7.02h-1.81l-.42-1.24Zm-.44-1.32l-.87-2.57-.86,2.57h1.73Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnsfea);
export default __webpack_public_path__ + "static/media/ensfea.3fd50e937919e29d230fa8586c9687e3.svg";
export { ForwardRef as ReactComponent };